import { PaymentMethodStoreInterfaceSnapshotOut } from './../state-manager/PaymentMethodStore'
export const PaymentMethodInitialStoreMock: PaymentMethodStoreInterfaceSnapshotOut = {
  code: '',
  integrationType: '',
  method: ''
}
